import { render, staticRenderFns } from "./ConfirmSignUp.vue?vue&type=template&id=58695960&scoped=true&"
import script from "./ConfirmSignUp.vue?vue&type=script&lang=js&"
export * from "./ConfirmSignUp.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSignUp.vue?vue&type=style&index=0&id=58695960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58695960",
  null
  
)

export default component.exports